import View from 'girder/views/View';
import JobStatus from 'girder_plugins/jobs/JobStatus';
import JobStatusDialogTemplate from '../../templates/widgets/jobStatusDialog.pug';
import '../../stylesheets/widgets/jobStatusEntry.styl';

import { formatDate, DATE_SECOND } from 'girder/misc';
import 'girder/utilities/jquery/girderModal';


/**
 * This view shows a dialog container detailing jobs done on this item.
 */
var JobStatusWidget = View.extend({
    initialize: function (settings) {
        this._fetchAndInit(settings);
    },

    render: function () {
        this.$el.html(JobStatusDialogTemplate({
            model: this.model,
            imageName: this.imageName,
            imageLocation: this.imageLocation,
            jobData: this.jobData,
            formatDate: formatDate,
            DATE_SECOND: DATE_SECOND,
            JobStatus: JobStatus
        })).girderModal(this);
        return this;
    },

    update: function (settings) {
        this._fetchAndInit(settings);
        this.render();
    },

    _fetchAndInit: function (params) {
        this.imageName = params.jobData.imagename;
        this.imageLocation = params.jobData.imagelocation;
        this.jobData = params.jobData.jobdata;
    },
});

export default JobStatusWidget;




// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/widgets/JobStatusWidget.js